import { Heart } from "lucide-react";
import { useLikes } from "@/context/LikesContext";

export function HeartButton({ item, className = "" }) {
  const { keys, toggle, enabled } = useLikes();
  if (!enabled || !item.place_key) return null;
  const on = keys.has(item.place_key);
  return (
    <button type="button" data-testid={`heart-button-${item.id}`} aria-pressed={on} aria-label={on ? "Remove from want to visit" : "Save to want to visit"}
      onClick={(e) => { e.stopPropagation(); toggle(item); }}
      className={`h-9 w-9 shrink-0 grid place-items-center rounded-full border transition-[transform,background-color,border-color] duration-200 active:scale-90 hover:scale-110 ${on ? "bg-[#FF3B6B]/15 border-[#FF3B6B]/60" : "bg-[#0B0F19]/80 border-[#26334D] backdrop-blur"} ${className}`}>
      <Heart className={`h-4 w-4 transition-colors ${on ? "fill-[#FF3B6B] text-[#FF3B6B]" : "text-slate-300"}`} />
    </button>
  );
}
